export default __webpack_public_path__ + "static/media/onlinelearn.03df4e18.jpg";